import React, { Component } from 'react';
import LedgerController from './ledger.controller';
import withHooks from '../../core/withHooks';
import Inherit from '../../core/inherit';
import { Card } from '../common';
import Page from '../common/page/Page';
import { SCOPES, userHasScope } from '../../constants/scopes.constants';
import LedgerTable from './elements/LedgerTable';
import LedgerTableActions from './elements/LedgerTableActions';

class Ledger extends Inherit(LedgerController, Component) {
    state = { loading: true, ledger: [], rows: [] };

    render() {
        const { loading, ledger, rows } = this.state;
        const canAction = userHasScope(this.data?.user, SCOPES.TEAM_INVITE);

        return (
            <Page
                isLoading={loading}
                scope={SCOPES.DASHBOARD_VIEW}
                title={{ text: 'Ledger' }}
                notificationContextHolder={this.props.notificationContextHolder}
            >
                <LedgerTableActions setRows={this.setRows.bind(this)} ledger={ledger} rows={rows} canAction={canAction} />
                <Card>
                    <LedgerTable rows={rows} loading={loading} />
                </Card>
            </Page>
        );
    }
}

export default withHooks(Ledger);
